module.exports = __webpack_public_path__ + "img/Weapon_267.b6b1bfff.png";